/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SettingTypeEnum = "config_settings" | "customs_types" | "default_folders" | "document_templates" | "document_types" | "email_templates" | "languages" | "miscellaneous_settings" | "ports" | "rate_cards" | "roles" | "shipment_types" | "shipping_lines" | "templates" | "%future added value";
export type infoAddSettingInput = {
    clientMutationId?: string | null;
    type: SettingTypeEnum;
    fields: Array<AddSettingField>;
};
export type AddSettingField = {
    name: string;
    value: unknown;
};
export type AddSettingDialogMutationVariables = {
    input: infoAddSettingInput;
};
export type AddSettingDialogMutationResponse = {
    readonly infoAddSetting: {
        readonly clientMutationId: string | null;
    } | null;
};
export type AddSettingDialogMutation = {
    readonly response: AddSettingDialogMutationResponse;
    readonly variables: AddSettingDialogMutationVariables;
};



/*
mutation AddSettingDialogMutation(
  $input: infoAddSettingInput!
) {
  infoAddSetting(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddSettingPayload",
    "kind": "LinkedField",
    "name": "infoAddSetting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddSettingDialogMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddSettingDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "80e0dafada874ba758add7155a3f0631",
    "id": null,
    "metadata": {},
    "name": "AddSettingDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AddSettingDialogMutation(\n  $input: infoAddSettingInput!\n) {\n  infoAddSetting(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f051ff62bb864ef753734bb0aa397a79';
export default node;
